import { render, staticRenderFns } from "./RealTimeData.vue?vue&type=template&id=19203d30&scoped=true"
import script from "./RealTimeData.vue?vue&type=script&lang=js"
export * from "./RealTimeData.vue?vue&type=script&lang=js"
import style0 from "./RealTimeData.vue?vue&type=style&index=0&id=19203d30&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19203d30",
  null
  
)

export default component.exports